<template>
  <div class="animated fadeIn">

    <b-form  @submit="addOrUpdateOrganizationRecord">
      <b-row>
        <b-col md="9" sm="12" class="mb-4">
          <h3 v-if="_.get(this.organization, 'id', false)" class="card-title mb-0">{{ this.organization.id }}</h3>
          <h3 v-if="!this.organization.id" class="card-title mb-0">Create New Organization</h3>
        </b-col>
      </b-row>
      <b-row>

        <b-col sm="12">
          <OrganizationForm :isNew="true" v-bind:organization="organization"></OrganizationForm>
             <b-alert
              fade
              :show="createOrganizationFailure"
              :variant="'danger'">
              <span v-html="createOrganizationFailure">
              </span>
            </b-alert>

          <b-row align-h="end">
            <b-col cols="auto" class="p-3">
              <b-button variant="link" href="/admin/organizations">Cancel</b-button>
              <b-button variant="primary" @click="addOrUpdateOrganizationRecord">Submit</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
      <h2 v-show="createOrganizationPending" class="u-padding-bottom-20">Updating, please wait ...</h2>
    <pulse-loader :loading="createOrganizationPending" color="#489AAC" size="50px"></pulse-loader>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OrganizationForm from '@/views/t1/Admin/OrganizationForm'

export default {
  name: 'addorganization',
  components: {
    OrganizationForm
  },
  computed: {
    ...mapGetters({
      organization: 'getCreateOrganization',
      createdOrganization: 'getRecentlyCreatedOrganization',
      createOrganizationPending: 'getCreateOrganizationPending',
      createOrganizationFailure: 'getCreateOrganizationFailure'
    })
  },
  data: function () {
    return {
    }
  },
  watch: {
    createdOrganization: function (newValue) {
      if (newValue) {
        // Send them back to the view user screen
        this.$router.push({ path: '/admin/organizations/' + newValue.id })
      }
    }
  },
  methods: {
    addOrUpdateOrganizationRecord () {
      this.$validator.validate().then(async (result) => {
        if (result) {
          this.organization.organizationTypes = JSON.stringify(this.organization.organizationTypes)
          this.organization.title = _.trim(this.organization.title)

          let newLocationList = []
          if (this.organization.locations) {
            newLocationList = this.organization.locations
            delete this.organization.locations
          }
          let newProgramList = []
          if (this.organization.programs) {
            newProgramList = this.organization.programs
            delete this.organization.programs
          }

          let defaultLocation = {}
          let defaultProgram = {}
          const orgData = this.organization
          const newOrganization = await this.$store.dispatch('createOrganization', orgData)
          this.$store.commit('resetCreateOrg')

          // Create new locations for the organization
          for (let i = 0; i < newLocationList.length; i++) {
            const location = newLocationList[i]
            if (location.isDefault) {
              defaultLocation = location
            }

            const newLocation = await this.$store.dispatch('createLocation', {
              title: location.title,
              addressStreet: location.addressStreet,
              addressCity: location.addressCity,
              addressCounty: location.addressCounty,
              addressState: location.addressState,
              addressZip: location.addressZip,
              latitude: location.latitude,
              longitude: location.longitude,
              organization: newOrganization.id
            })

            if (defaultLocation.title === newLocation.title) {
              await this.$store.dispatch('updatedOrganization', {
                id: newLocation.organization.id,
                data: {
                  defaultLocation: newLocation.id
                }
              })
            }
          }

          // Create new programs for the organization
          for (let i = 0; i < newProgramList.length; i++) {
            const program = newProgramList[i]
            if (program.isDefault) {
              defaultProgram = program
            }
            const newProgram = await this.$store.dispatch('createProgram', {
              organization: newOrganization.id,
              title: program.title,
              title_otherText: program.title_otherText
            })

            const shouldSetProgramAsDefault = newProgram.title === 'Other'
              ? newProgram.title_otherText === defaultProgram.title_otherText
              : newProgram.title === defaultProgram.title
            if (shouldSetProgramAsDefault) {
              await this.$store.dispatch('updatedOrganization', {
                id: newProgram.organization.id,
                data: {
                  defaultProgram: newProgram.id
                }
              })
            }
          }
        }
      })
    }
  },
  beforeDestroy () {
    // this.$store.commit('resetCreateOrg')
  }
}
</script>


// WEBPACK FOOTER //
// src/views/t1/Admin/AddOrganization.vue